"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInteriorPointOfArray = getInteriorPointOfArray;
exports.getInteriorPointsOfMultiArray = getInteriorPointsOfMultiArray;

var _contains = require("./contains.js");

var _array = require("../../array.js");

/**
 * @module ol/geom/flat/interiorpoint
 */

/**
 * Calculates a point that is likely to lie in the interior of the linear rings.
 * Inspired by JTS's com.vividsolutions.jts.geom.Geometry#getInteriorPoint.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @param {number} flatCentersOffset Flat center offset.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Destination point as XYM coordinate, where M is the
 * length of the horizontal intersection that the point belongs to.
 */
function getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, opt_dest) {
  var i, ii, x, x1, x2, y1, y2;
  var y = flatCenters[flatCentersOffset + 1];
  /** @type {Array<number>} */

  var intersections = []; // Calculate intersections with the horizontal line

  for (var r = 0, rr = ends.length; r < rr; ++r) {
    var end = ends[r];
    x1 = flatCoordinates[end - stride];
    y1 = flatCoordinates[end - stride + 1];

    for (i = offset; i < end; i += stride) {
      x2 = flatCoordinates[i];
      y2 = flatCoordinates[i + 1];

      if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
        x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
        intersections.push(x);
      }

      x1 = x2;
      y1 = y2;
    }
  } // Find the longest segment of the horizontal line that has its center point
  // inside the linear ring.


  var pointX = NaN;
  var maxSegmentLength = -Infinity;
  intersections.sort(_array.numberSafeCompareFunction);
  x1 = intersections[0];

  for (i = 1, ii = intersections.length; i < ii; ++i) {
    x2 = intersections[i];
    var segmentLength = Math.abs(x2 - x1);

    if (segmentLength > maxSegmentLength) {
      x = (x1 + x2) / 2;

      if ((0, _contains.linearRingsContainsXY)(flatCoordinates, offset, ends, stride, x, y)) {
        pointX = x;
        maxSegmentLength = segmentLength;
      }
    }

    x1 = x2;
  }

  if (isNaN(pointX)) {
    // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
  }

  if (opt_dest) {
    opt_dest.push(pointX, y, maxSegmentLength);
    return opt_dest;
  } else {
    return [pointX, y, maxSegmentLength];
  }
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @return {Array<number>} Interior points as XYM coordinates, where M is the
 * length of the horizontal intersection that the point belongs to.
 */


function getInteriorPointsOfMultiArray(flatCoordinates, offset, endss, stride, flatCenters) {
  var interiorPoints = [];

  for (var i = 0, ii = endss.length; i < ii; ++i) {
    var ends = endss[i];
    interiorPoints = getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
    offset = ends[ends.length - 1];
  }

  return interiorPoints;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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